var RadiusChange = /** @class */ (function () {
    function RadiusChange(range, input, top_image, bottom_image) {
        this.range = range;
        this.input = input;
        this.top_image = top_image;
        this.bottom_image = bottom_image;
        this.checkRequiredParameters();
        this.setEventListeners();
        var raph = this.generateRaphael();
        if (raph === null) {
            throw new Error("src attribute not type of string");
        }
        this.raph_element = raph;
        this.onRadiusRangeChange(this);
        // image.animate({"transform": "r45, 94, 97"} );
        // image.style.rotate = "45deg";
        // image.style.transform = "rotate(90deg)";
        // image.style.transformOrigin = "bottom center"
        // image.setAttribute("transform", 'matrix(1, 0, 0, 1, 0, 0)');
        // let svgTransform = new SVGTransform()
        // svgTransform.setMatrix(new SVGMatrix("matrix(1, 0, 0, 1, 0, 0"));
        // image.transform.baseVal.appendItem(svgTransform);
    }
    RadiusChange.prototype.checkRequiredParameters = function () {
        console.log(this.range);
        if (this.range.type != "range") {
            throw new Error("The Range Input should have a type of range");
        }
        else if (!this.range.hasAttribute("min")) {
            throw new Error("The min attribute is mandatory for the range input!");
        }
        else if (!this.range.hasAttribute("max")) {
            throw new Error("The max attribute is mandatory for the range input!");
        }
        else if (!this.range.hasAttribute("step")) {
            throw new Error("The step attribute is mandatory for the range input!");
        }
        if (this.input.type != "number") {
            throw new Error("The Input Input should have a type of Number");
        }
    };
    RadiusChange.prototype.generateRaphael = function () {
        var image = this.bottom_image.getElementsByTagName("img")[0];
        var src = image.getAttribute("src");
        image.remove();
        var Raph = window.Raph;
        var R = new Raph("fitting_bottom", 180, 202);
        console.log(R);
        if (typeof src === "string") {
            console.log("Source");
            var I = R.image(src, 0, 0, 180, 200);
            // console.log(I);
            // @ts-ignore
            I.stop().animate({ transform: 'r0, 94, 94' }, 1, "<>");
            return I;
        }
        return null;
    };
    RadiusChange.prototype.setRaphaelRadius = function (raph_element, radius) {
        //@ts-ignore
        raph_element.stop().animate({ transform: 'r' + radius + ', 94, 94' }, 1, '<>');
    };
    RadiusChange.prototype.setEventListeners = function () {
        var $this = this; //Needed because this get treated as different object in listener.
        this.range.addEventListener("change", function (e) {
            e.preventDefault();
            $this.onRadiusRangeChange($this);
        });
        this.range.addEventListener("input", function (e) {
            e.preventDefault();
            $this.onRadiusRangeInput($this);
        });
        this.input.addEventListener("change", function (e) {
            e.preventDefault();
            $this.onRadiusInputChange($this);
        });
    };
    RadiusChange.prototype.onRadiusRangeChange = function (main) {
        var value = parseInt(main.range.value);
        var max = parseInt(main.range.getAttribute("max"));
        var total = (90 / max * value) + 5;
        main.range.style.backgroundImage = "linear-gradient(90deg, #E57B25 0% " + total + "%, #C5C5C5 " + total + "% 100%)";
        main.input.value = main.range.value;
        this.moveBottomPillar();
        console.log(main.raph_element);
        main.setRaphaelRadius(main.raph_element, value);
    };
    RadiusChange.prototype.onRadiusRangeInput = function (main) {
        var value = parseInt(main.range.value);
        var max = parseInt(main.range.getAttribute("max"));
        var total = (90 / max * value) + 5;
        main.range.style.backgroundImage = "linear-gradient(90deg, #E57B25 0% " + total + "%, #C5C5C5 " + total + "% 100%)";
        main.input.value = main.range.value;
        this.moveBottomPillar();
        console.log(main.raph_element);
        main.setRaphaelRadius(main.raph_element, value);
    };
    RadiusChange.prototype.onRadiusInputChange = function (main) {
        main.range.value = main.input.value;
        main.onRadiusRangeChange(main);
    };
    RadiusChange.prototype.onRadiusInputInput = function (main) {
        main.range.value = main.input.value;
        main.onRadiusRangeInput(main);
    };
    RadiusChange.prototype.moveBottomPillar = function () {
        var image = this.bottom_image.getElementsByTagName("image")[0];
        var max = this.range.max;
        var value = this.range.value;
        var total = parseInt(max) / 100 * parseInt(value);
        console.log(total);
        // console.log(new DOMMatrix( "matrix(0.1219, 0.9925, -0.9925, 0.1219, 178.821, -8.1207"));
        // console.log(new DOMMatrix( "matrix(1, 0, 0, 1, 0, 0"));
        // image.transform.baseVal.createSVGTransformFromMatrix(new DOMMatrix( "matrix(1, 0, 0, 1, 0, 0"));
        // image.transform.animVal.createSVGTransformFromMatrix(new SVGMatrix(new DOMMatrix("matrix(0.1219, 0.9925, -0.9925, 0.1219, 178.821, -8.1207")));
        // this.bottom_image.getElementsByTagName("image")[0].style.transform = 'matrix(0.1219, 0.9925, -0.9925, 0.1219, 178.821, -8.1207);';
    };
    return RadiusChange;
}());
export { RadiusChange };
